import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FaqWidgetBaseComponent } from '@resident-nx/shared';
import { IconWebComponent } from '@resident-nx/web/ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'rs-web-faq-widget',
  templateUrl: './faq-widget.component.html',
  styleUrls: ['./faq-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconWebComponent, TranslateModule],
})
export class FaqWidgetWebComponent extends FaqWidgetBaseComponent {}
